import styles from "./Input.module.css";

interface InputProps {
  readonly type?: "text" | "email" | "password" | "number" | "date";
  readonly name: string;
  readonly id?: string;
  readonly placeholder?: string;
  readonly value?: string;
  readonly onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  readonly required?: boolean;
  readonly disabled?: boolean;
  readonly error?: boolean;
  readonly min?: number;
  readonly max?: number;
  readonly step?: number;
  readonly dark?: boolean;
  readonly className?: string;
  readonly "aria-label"?: string;
  readonly "aria-describedby"?: string;
}

export function Input({
  type = "text",
  name,
  id,
  placeholder,
  value,
  onChange,
  required,
  disabled,
  error,
  min,
  max,
  step,
  dark,
  className,
  "aria-label": ariaLabel,
  "aria-describedby": ariaDescribedBy,
}: InputProps) {
  return (
    <input
      type={type}
      name={name}
      id={id}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      required={required}
      disabled={disabled}
      min={min}
      max={max}
      step={step}
      aria-label={ariaLabel}
      aria-describedby={ariaDescribedBy}
      aria-invalid={error || undefined}
      className={`${styles.input} ${dark ? styles.dark : ""} ${error ? styles.error : ""} ${className ?? ""}`}
    />
  );
}
